// import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  // useHistory,
} from "react-router-dom";

import { ProvideAuth, useAuth } from "./use-auth.js";
import { SecureRoute } from "./secure-route.js";
import { AdminRoute } from "./admin-route.js";

// import logo from './logo.svg';
import './App.css';

import { BaseWrapper } from './components/base-wrapper.js';

import { LogIn } from './components/login'
import { RegisterPage } from './components/register'
import { ForgotPasswordPage } from './components/forgot-password'
import { PaymentPage } from './components/payment'
import { SubscribePage } from "./components/subscribe";
import { RenewSubscrPage } from "./components/renew-subscr";
import { ThankPaymentPage } from './components/thank-payment'

import { AdminBillPage } from './components/admin-bill'
import { AdminPayPage } from './components/admin-pay'
import { AdminSubscriptionPage } from './components/admin-subs'
import { AdminMemberPage } from './components/admin-member'
import { AdminAppPage } from './components/admin-app'

import { MemberBillPage } from './components/member-bill'
import { MemberHomePage } from './components/member-home'
import { MemberProfilePage } from './components/member-profile'
import { MemberPasswordPage } from './components/member-password'
import { MemberSubscriptionPage } from './components/member-subs'
import { MemberAppListPage } from "./components/member-applist.js";

import { useEffect } from "react";

function App() {
  // eslint-disable-next-line no-unused-vars
  const auth = useAuth();

  return (
    <ProvideAuth>
      <Router>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>

          <Route exact path="/login">
            <LogIn />
          </Route>

          <Route exact path="/register">
            <RegisterPage />
          </Route>

          <Route exact path="/forgot-password">
            <ForgotPasswordPage />
          </Route>

          <Route path="/subscribe/:app_id">
            <SubscribePage />
          </Route>

          <Route path="/renew/:pkg_id">
            <RenewSubscrPage />
          </Route>

          <Route exact path="/payment">
            <PaymentPage />
          </Route>

          <Route exact path="/thank-payment">
            <ThankPaymentPage />
          </Route>

          <SecureRoute path="/member">
            <BaseWrapper>
              <Switch>
                <Route exact path="/member/home">
                  <MemberHomePage />
                </Route>

                <Route exact path="/member/profile">
                  <MemberProfilePage />
                </Route>

                <Route exact path="/member/password">
                  <MemberPasswordPage />
                </Route>

                <Route path="/member/bill">
                  <MemberBillPage />
                </Route>

                <Route path="/member/subs">
                  <MemberSubscriptionPage />
                </Route>

                <Route path="/member/apps">
                  <MemberAppListPage />
                </Route>
                
              </Switch>
            </BaseWrapper>
          </SecureRoute>

          <AdminRoute path="/admin">
            <BaseWrapper>
              <Switch>
                <Route exact path="/admin/home">
                  <p>Hi, You are administrator</p>
                </Route>
                
                <Route path="/admin/payment">
                  <AdminPayPage />
                </Route>

                <Route path="/admin/bill">
                  <AdminBillPage />
                </Route>

                <Route path="/admin/subs">
                  <AdminSubscriptionPage />
                </Route>

                <Route path="/admin/member">
                  <AdminMemberPage />
                </Route>

                <Route path="/admin/app">
                  <AdminAppPage />
                </Route>

              </Switch>
            </BaseWrapper>
          </AdminRoute>
        </Switch>
      </Router>
    </ProvideAuth>
  );
}

export default App;

function Home() {
  useEffect(() => {
    document.location.href = '/welcome.html';
  }, [])

  return (
    <div>
      <h2>Redirect to Welcome Page</h2>
      <Link className="btn btn-info d-none" to="/login">Log In to System</Link>
    </div>
  );
}

